export default "__VITE_ASSET__BFQQP2eh__"